<nb-card>
  <nb-card-header>
    {{ translations.changedProductFieldLabels.catalogs }}

    &nbsp;
    @if (canEdit) {
      <app-choose-catalog-input (removeCatalogEvent)="onRemoveAdditionalCatalogFromModal($event)"
                                (catalogChosenEvent)="onCatalogSelected($event)"
                                [onlyOneSelection]="false"
                                [chooseOnlyLastLevel]="true"
                                [chosenCatalogs]="catalogs || []"
                                [excludeCatalogIds]="excludeCatalogIds"/>
    }
  </nb-card-header>

  <nb-card-body>
    @if (!canEdit) {
      <p i18n="@@SohraniteTovarPeredRedaktirovaniemDopoln">Сохраните товар перед редактированием дополнительных категорий</p>
    }
    @if (catalogs?.length) {
      <nb-tag-list>
        @for (catalog of catalogs; track catalog) {
          <nb-tag appearance="outline" status="primary" [text]="catalog.header" [removable]="true" (remove)="removeAdditionalCatalog(catalog)"/>
        }
      </nb-tag-list>
    }
  </nb-card-body>

</nb-card>
